import { ViewerContext } from 'dash-ui';
import { useContext, useEffect, type FC } from 'react';
import { Navigate } from 'react-router-dom';

import renderBranch from 'common/helpers/renderBranch';
import { type AuthorizedRouteProps } from 'flow-components/routes/interfaces';
import { useGetCurrentDeveloperUserQuery } from 'gql/generated.graphql';

const AuthorizedRoute: FC<AuthorizedRouteProps> = ({
  authorized,
  redirect,
  children,
}) => {
  const { setDeveloper } = useContext(ViewerContext);
  const { data } = useGetCurrentDeveloperUserQuery();

  useEffect(() => {
    if (data && authorized && setDeveloper) {
      const { type } = data.getCurrentDeveloperUser;

      setDeveloper({ type });
    }
  }, [authorized, data, setDeveloper]);

  return renderBranch(
    authorized,
    <>{children}</>,
    <Navigate to={redirect} replace />
  );
};

export default AuthorizedRoute;
